export default __webpack_public_path__ + "static/Volcano-469e1413c4b83f4ad29ba2df9ac5f709.woff";